import CapitalizationUtil from "../../utils/CapitalizationUtil.ts";
import { GenericResponseType } from "../../types/response.ts";
import { Agent } from "../../types/agent.ts";
import { COMMON_API_URL } from "../../constants/urls";

type KeyConversionType = "camelCase" | "topLevel" | "none";

interface FetchOptions {
  convertKeys?: KeyConversionType;
}

const fetchData = async (
  jwt: string,
  endpoint: string,
  body: any = {},
  options: FetchOptions = {}
): Promise<any> => {
  const { convertKeys = "topLevel" } = options;

  const response = await fetch(`${COMMON_API_URL}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  let data: GenericResponseType;

  switch (convertKeys) {
    case "camelCase":
      data = CapitalizationUtil.convertKeysToCamelCase(await response.json());
      break;
    case "none":
      data = await response.json();
      break;
    default:
      data = CapitalizationUtil.convertTopLevelKeysToCamelCase(
        await response.json()
      );
  }

  if (data.error) {
    throw new Error(data.error);
  }

  return data.result.agentData ?? data.result;
};

const fetchAgentsList = async (jwt: string): Promise<Agent[]> => {
  const result = await fetchData(jwt, "getAgentsList", {});
  return result as Agent[];
};

const AgentsService = {
  getAllAgents: (jwt: string) => fetchData(jwt, "getAgents", { all: true }),

  getAgentById: (jwt: string, id: string) =>
    fetchData(jwt, "getAgentData", { AID: id, all: true }),

  saveAgent: (jwt: string, agentData: object) =>
    fetchData(jwt, "agent_write", agentData),

  getSubAgentsIdsByAgentId: (jwt: string, id: string) =>
    fetchData(jwt, "getAgentsToDiv", { div: id }),

  getAgentsList: (jwt: string) => fetchAgentsList(jwt),

  saveAgentsToOffice: (jwt: string, div: string, agents: string[]) =>
    fetchData(jwt, "AgentsToDiv_write", { div, agents }),

  getAgentReportIdByAgentId: (jwt: string, id: string) =>
    fetchData(jwt, "getAgentCntr", { AID: id }),

  getAgentsAndOffices: (jwt: string) => fetchData(jwt, "getDeltaAgents", {}),
};

export default AgentsService;
